import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {ErrorToaster, SuccessToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {useNavigate} from "react-router";
import {EmptyState} from "../../../components/fouladyar/empty-state/emptyState";
import {LoadingState} from "../../../components/fouladyar/loading-state/loadingState";
import RequestApprovalNewVrsionItem from "./component/requestApprovalNewVersionItem";
import {LuPackagePlus} from "react-icons/lu";
import ModalHelper from "../../../components/fouladyar/modal-helper/modalHelper";
import {AddMemberModal} from "../bot/User-facing/EditBot/components/addMemberModal";
import {RejectPublicationReasonModal} from "./component/rejectPublicationReasonModal/rejectPublicationReasonModal";

const RequestApprovalNewPublish = () => {

    const {t, i18n} = useTranslation();
    const auth = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const [publications, setPublications] = useState([]);
    const [modalComponent, setModalComponent] = useState(<div> empty </div>);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const [isApplyingFilter, setIsApplyingFilter] = useState(false);
    const [pagination, setPagination] = useState({
        itemPerPage: 7,
        currentPage: 1,
        totalItems: 0,
        lastUpdateBy: ''
    })

    const [filter, setFilter] = useState({})

    async function initializeData() {

        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/publication/bot/all/admin`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            console.log('data', res)

            if (res.data.statusCode === 200 || !res.data.statusCode) {
                setPublications(res.data.data.publications)
                setPagination({...pagination, totalItems: res.data.data.totalItems || 9, lastUpdateBy: 'initializer'})
                setIsLoading(false)
                setIsModalOpen(false);
            }


        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    async function fetchData(updater) {
        try {
            setIsLoading(true)
            const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/bot/version/admin/all`, {
                headers: {authorization: `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200) {
                setPublications(res.data.data.publication)
                if (updater === 'filter')
                    setPagination({
                        ...pagination,
                        totalItems: res.data.data.totalItems,
                        currentPage: 1,
                        lastUpdateBy: updater
                    })
                setIsLoading(false)
            }


        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }

    useEffect(() => {
        initializeData();
    }, []);


    useEffect(() => {
        if(reload){
            initializeData();
            setReload(false)
        }
    }, [reload]);


    useEffect(() => {
        if (pagination.lastUpdateBy === "pagination")
            fetchData('pagination');

    }, [pagination]);


    useEffect(() => {
        fetchData('filter');
    }, [filter]);



    async function publish(botId, publicationId) {
        try {
            setIsLoading(true)
            const res = await axios.put(`${process.env.REACT_APP_API_URL}/api/publication/bot/publish/${botId}/${publicationId}`, {},{
                headers: {"authorization": `Bearer ${auth.token}`}
            })


            if (res.data.statusCode === 200) {
                setReload(true)
                setIsLoading(false)
                initializeData()
                SuccessToaster({message: 'نسخه جدید با موفقیت تایید شد'})
            }

        } catch (e) {
            ErrorToaster(e, t)
            setIsLoading(false)
        }
    }



    return (
        <React.Fragment>
            <ModalHelper
                size={"lg"}
                open={isModalOpen}
                onOpen={() => setIsModalOpen(true)}
                onClose={() => setIsModalOpen(false)}
                component={modalComponent}
            />
            <div className="grid">
                {/*<div className="grid-header license-header">
                    <div className="grid-header-image">
                        <div dangerouslySetInnerHTML={{__html: FACE_ID_SVG}}/>
                    </div>
                    <div className="d-flex flex-column flex-grow-1 bot-selector">
                        <h3>احراز هویت صرافی</h3>
                    </div>
                    <div className="grid-actions">
                        <button className="btn small-button grid-action-btn" type="button" onClick={() => {
                            navigate(`${process.env.FXPILOT_BASE_URL}/identify/add`)
                        }}>
                            <IoAddOutline size={17} color={"#49e7ad"}/>
                        </button>
                    </div>
                </div>
*/}
                <div className="container-fluid select-plan-container">
                    <h1>{"درخواست های انتشار"}</h1>
                    <div className="spacer"/>
                    <h3 style={{border: 'unset'}}>
                        توسعه دهندگان ای که درخواست انتشار ربات خود را دارند در اینجا قابل نمایش است
                    </h3>
                    <p>
                        کاربر ادمین گرامی، در صورتی که بخش های مخلف ربات کاربر مطابق با شرایط و قوانین انتشار سایت است، نسخه مورد نظر را تایید و منتشر کنید.
                    </p>
                    <div className="spacer"/>
                </div>
                <div className="identify-card-container">
                    {
                       isLoading ? <LoadingState/> :
                           publications?.length === 0 ?
                               <EmptyState
                                   title="انتشار در پایگاه داده یافت نشد"
                                   content="هیچ کاربری در حال حاضر درخواست انتشار ربات نداده است"
                                   icon={<LuPackagePlus size={60} color={"#38AF84"}/>}
                                   doNotUseButton={true}
                               />:
                               publications?.map(item => {
                                   return (
                                       <RequestApprovalNewVrsionItem
                                           _id={item?._id}
                                           createdAt={item?.createdAt}
                                           isRequesting={isLoading}
                                           name={item?.extras?.name}
                                           changes={item?.version?.changes}
                                           version={item?.extras?.version}
                                           file={item?.version?.file?.original?.path}
                                           developerName={item?.developer?.fullName}
                                           onApprove={async () => {
                                               await publish(item?.entityId, item?._id)
                                           }}
                                           onReject={async (id) => {
                                               // await reject(item?._id)
                                               setModalComponent(
                                                   <RejectPublicationReasonModal
                                                       publicationId={item?._id}
                                                       onReload={async () => {
                                                           SuccessToaster({message: 'لغو انتشار با موفقیت انجام شد'})
                                                           await initializeData()
                                                       }}
                                                       onClose={() => {
                                                           setIsModalOpen(false);
                                                       }}
                                                       onCancel={() => {
                                                           setIsModalOpen(false);
                                                       }}
                                                   />
                                               )
                                               setIsModalOpen(true)
                                           }}
                                       />
                                   )
                               })
                    }
                </div>
            </div>


        </React.Fragment>
    );
};

export default RequestApprovalNewPublish;



